// src/pages/SignUpPage.js
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../supabaseClient'

function SignUpPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  const handleSignup = async (e) => {
    e.preventDefault()
    setError(null)

    const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
      email,
      password,
    })

    if (signUpError) {
      setError(signUpError.message)
      return
    }

    const userId = signUpData.user.id

    // Insert into users table
    const { error: insertError } = await supabase.from('users').insert([
      {
        id: userId,
        full_name: email.split('@')[0],
        role: 'viewer',
      },
    ])

    if (insertError) {
      setError('Signup succeeded, but failed to create user profile.')
      console.error(insertError)
    }

    navigate('/dashboard')
  }

  return (
  <div
    style={{
      minHeight: '100vh',
      backgroundColor: '#f1f5f9',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      fontFamily: 'Arial, sans-serif',
    }}
  >
    <div
      style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        padding: '2rem',
        width: '100%',
        maxWidth: '400px',
      }}
    >
      <h2
        style={{
          fontSize: '1.75rem',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#0f172a',
          marginBottom: '1.5rem',
        }}
      >
        Sign Up to get access to CuvrIQ
      </h2>

      <form onSubmit={handleSignup}>
        <label style={{ display: 'block', marginBottom: '0.5rem', color: '#334155' }}>
          Email
        </label>
        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{
            width: '100%',
            padding: '0.75rem',
            marginBottom: '1rem',
            border: '1px solid #cbd5e1',
            borderRadius: '6px',
            fontSize: '1rem',
          }}
        />

        <label style={{ display: 'block', marginBottom: '0.5rem', color: '#334155' }}>
          Password
        </label>
        <input
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{
            width: '100%',
            padding: '0.75rem',
            marginBottom: '1rem',
            border: '1px solid #cbd5e1',
            borderRadius: '6px',
            fontSize: '1rem',
          }}
        />

        {error && (
          <p style={{ color: '#ef4444', marginBottom: '1rem', fontSize: '0.9rem' }}>{error}</p>
        )}

        <button
          type="submit"
          style={{
            width: '100%',
            backgroundColor: '#2563eb',
            color: '#ffffff',
            padding: '0.75rem',
            borderRadius: '6px',
            fontWeight: 'bold',
            fontSize: '1rem',
            border: 'none',
            cursor: 'pointer',
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#1d4ed8')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#2563eb')}
        >
          Sign Up
        </button>
      </form>

      <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.95rem', color: '#475569' }}>
        Already have an account?{' '}
        <a href="/login" style={{ color: '#2563eb', textDecoration: 'underline' }}>
          Log In
        </a>
      </p>
    </div>
  </div>
)

}

export default SignUpPage
